import { render, staticRenderFns } from "./index.vue?vue&type=template&id=288ef63c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=288ef63c&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&module=true&"
import style2 from "./index.vue?vue&type=style&index=2&lang=scss&module=styleSpacer&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)
this["styleSpacer"] = (style2.locals || style2)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "288ef63c",
  null
  
)

export default component.exports